import { useLocation } from "@reach/router"
import { useEffect } from "react"

const RouteChangeTracker = ({ onRouteChange, onPageLeave }) => {
  const location = useLocation()

  useEffect(() => {
    if (onRouteChange) {
      onRouteChange(location.pathname)
    }
  }, [location, onRouteChange])

  useEffect(() => {
    const onDocumentVisibilityChange = () => {
      if (document.visibilityState === "hidden" && onPageLeave) {
        onPageLeave(window.location.pathname)
      }
    }

    document.addEventListener("visibilitychange", onDocumentVisibilityChange)

    return () => {
      document.removeEventListener(
        "visibilitychange",
        onDocumentVisibilityChange
      )
    }
  }, [])

  return null
}

export default RouteChangeTracker
